module.exports = __webpack_public_path__ + "img/i-add-white.d1b44465.svg";